export default __webpack_public_path__ + "static/media/not-found.df717166.png";